<template>
	<div class="instagram ">
		<div v-html="content.description" class="instagram__title"></div>

		<div class="instagram__action">
			<ButtonComponent label="Følg oss på Instagram" tag="a" href="https://www.instagram.com/interiorverkstedet/" />
		</div>

		<div class="elfsight-app-b74cc41f-0fd1-4491-b5c3-25b18738bee7"></div>
	</div>
</template>

<script>
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},

	metaInfo: {
		script: [{ type: 'text/javascript', src: 'https://apps.elfsight.com/p/platform.js' }],
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.instagram {
	@include respond-below('phone') {
		margin-bottom: 0 !important;
	}
	&__action {
		text-align: center;
		padding: 1rem 0 3rem;
	}
	&__title {
		text-align: center;
	}
}
.eapps-instagram-feed-title {
	display: none !important;
}
</style>
